import * as Widget from './base';
import * as WidgetHelper from './helper';

function setup_close_button(config) {
  var modal = Widget.get(config);

  if (modal) {
    var close_button = modal.querySelector('.driftrock-close')

    close_button.addEventListener('click', function (e) {
      hide(config);
    });
  }
}

export function show(config) {
  var modal = Widget.get(config);

  if (modal) {
    document.body.classList.add('driftrock-body-with-modal');
    modal.classList.remove('invisible');
  }
}

export function hide(config) {
  var modal = Widget.get(config);

  if (modal) {
    document.body.classList.remove('driftrock-body-with-modal');
    modal.classList.add('invisible');
  }
}

export function toggle(config) {
  Widget.toggle(config);
}

export function init(config) {
  if (Driftrock.settings.debug) {
    console.info(`[Driftrock] Initialising modal widget: ${config.widget.id}`);
  }

  if (config.widget_html) {
    document.body.insertAdjacentHTML('beforeend', config.widget_html)

    Widget.init_content(config);

    WidgetHelper.setup_open(config, show);

    setup_close_button(config);
  }
}
